<template>
  <div
    v-if="definitionsByQuality"
    class="rent-buy">
    <div class="buy-buttons">
      <btn-action-price
        v-if="isQualitySD"
        :definitions="definitionsByQuality.SD"
        :selected-quality="quality"
        :item="item"
        @select="clickBuyOrRent" />
      <btn-action-price
        v-else-if="isQualityHD"
        :definitions="definitionsByQuality.HD"
        :selected-quality="quality"
        :item="item"
        @select="clickBuyOrRent" />
    </div>
    <bookmarks-button
      :item="item"
      :can-be-bookmarked="canBeBookmarked" />
    <switch-quality
      v-if="showSwitch"
      :definitions="definitionsByQuality"
      :selected-quality="quality"
      class="switch-quality"
      @select="selectQuality" />
    <div
      v-if="item.rentalAvailabilityDate"
      class="rental-soon-available">
      {{ $t('fip.rentalSoonAvailable', { date: $options.filters.conversionDateTimestamp(item.rentalAvailabilityDate) }) }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BtnActionPrice from './btnActionPrice/BtnActionPrice'
import SwitchQuality from './switchQuality/SwitchQuality.vue'
import BookmarksButton from '../bookmarksButton/BookmarksButton'
import apiConstants from '../../../../../api.constants'
import _get from 'lodash/get'

export default {
  name: 'RentBuy',
  components: {
    BtnActionPrice,
    SwitchQuality,
    BookmarksButton
  },
  props: {
    definitionsByQuality: {
      type: Object,
      required: true
    },
    selectedQuality: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    isPlaying: {
      type: Boolean,
      default: false
    },
    canBeBookmarked: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      userQualification: 'user/getUserQualification',
      getBookmarkById: 'bookmarks/getBookmarkById',
      getSelectedQuality: 'fip/getSelectedQuality',
      alerts: 'alerts/getAlerts'
    }),
    quality () {
      // fix #3883 pour les contenus qui n'ont pas de comm SD, les boutons acheter/louer ne s'affichent pas
      return !this.definitionsByQuality.SD && this.definitionsByQuality.HD ? 'HD' : this.getSelectedQuality || this.selectedQuality
    },
    myAlerts () {
      return _get(this.alerts, 'articles.items', [])
    },
    isInMyAlerts () {
      return this.myAlerts.find(item => item.id === this.item.id)
    },
    isQualityHD () {
      return this.selectedQuality === apiConstants.PROMO.QUALITY_HD && this.definitionsByQuality.HD
    },
    isQualitySD () {
      return this.selectedQuality === apiConstants.PROMO.QUALITY_SD && this.definitionsByQuality.SD
    },
    showSwitch () {
      return this.definitionsByQuality.SD && this.definitionsByQuality.HD && !this.isPlaying
    },
    bookmarkId () {
      return _get(this.getBookmarkById(this.item.id), 'bookmarkId', null)
    },
    bookmarked () {
      return this.bookmarkId !== null
    },
    isAlert () {
      return !!this.isInMyAlerts
    }
  },
  methods: {
    selectQuality (quality) {
      this.$emit('select-quality', quality)
    },
    clickBuyOrRent (definition) {
      this.sendStats(this.$stats.fip.onClickBuyOrRent(this.item, definition, this.userQualification, this.isAlert, this.bookmarked))
      this.$emit('buy-rent', definition)
    }
  }
}
</script>

<style lang="scss" scoped>
  .rent-buy {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    @include mediaQueries('width', (xsmall: 100%, medium: auto));
    @include mediaQueries('flex-direction', (xsmall: row));

    .buy-buttons {
      position: relative;
      z-index: 9;
      display: flex;
      @include mediaQueries('flex-direction', (xsmall: column, medium: row));
      @include mediaQueries('width', (xsmall: 100%, large: auto));
      @include mediaQueries('margin-right', (xsmall: 0, medium: 30px));
    }

    .rental-soon-available {
      font-size: 16px;
      @include mediaQueries("padding", (xsmall: 10px 0 0, small: 15px 0 0 0, medium: 14px 10px, large: 14px 20px 14px 10px));
      @include mediaQueries("width", (xsmall: 100%, small: auto));
      color: $white;
    }

    .switch-quality {
      z-index: 9;
      @include mediaQueries('position', (xsmall: absolute, large: relative));
      @include mediaQueries('top', (xsmall: 45px, large: 1px));

      &:not(:last-child) {
        @include mediaQueries('margin-right', (small: 1px));
      }
    }
  }
</style>
